import { Skeleton } from "./ui/skeleton";

export function ProductCardSkeleton() {
  return (
    <div className="overflow-hidden border rounded-xl group transition-shadow duration-200 ease-out-cubic flex flex-col max-h-[320px] md:max-h-[360px] shadow-sm hover:shadow-sm bg-card text-card-foreground">
      <div className="h-[140px] xs:h-[120px] overflow-hidden bg-[var(--dispensary-gray-100)]">
        <Skeleton className="w-full h-full" />
      </div>
      <div className="p-4">
        <div className="flex flex-wrap gap-1 mb-3">
          <Skeleton className="h-5 w-20" />
        </div>
        <Skeleton className="h-6 w-3/4 mb-2" />
        <Skeleton className="h-5 w-1/4" />
      </div>
      <div className="p-4 pt-0 flex gap-2">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  );
}